import React from 'react';

function AdvancedText () {
    return(
        <div className="GuideTextPara">
            <h5>Advanced Guide:</h5>
            <p>Test</p>
        </div>
    )
}

export default AdvancedText;